import App from 'app/app.js';

function TranslationFactory($http, $q) {
  return function (options) {
    var deferred = $q.defer();
    var url = 'translate/' + options.key;
    $http({ method: 'GET', url: url })
      .then(function (response) {
        if (response.data.success) {
          deferred.resolve(response.data.data.transMap);
        }
      })
      .catch(function () {
        deferred.reject(options.key);
      });

    return deferred.promise;
  };
}

App.factory('TranslationFactory', ['$http', '$q', TranslationFactory]);
